var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/"}},[(_vm.logoIcon)?_c('img',{staticClass:"logo-img",attrs:{"src":require("../assets/logo-dark.svg"),"alt":"bet-magic-logo"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }